'use strict';

var React = require('react');

var SvgDomainFilledIcon = function SvgDomainFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.25a.75.75 0 0 1 .75-.75h11a.75.75 0 0 1 0 1.5h-10.25v8.25a.75.75 0 0 1-1.5 0v-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.565 11.46a.5.5 0 0 0-.606.605l1.122 4.51a.5.5 0 0 0 .838.234l1.165-1.165.84.841a.5.5 0 0 0 .708 0l.353-.353a.5.5 0 0 0 0-.707l-.84-.841 1.163-1.165a.5.5 0 0 0-.232-.838l-4.51-1.122Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 6.75a.75.75 0 0 1 .75-.75h11a.75.75 0 0 1 .75.75v4.785c-.05-.018-.1-.033-.153-.046l-4.51-1.121a1.625 1.625 0 0 0-1.97 1.969l1.036 4.163h-6.153a.75.75 0 0 1-.75-.75v-9Zm11 1.75h-9.5v-1h9.5v1Z"
  }));
};
SvgDomainFilledIcon.displayName = "DomainFilledIcon";

exports.SvgDomainFilledIcon = SvgDomainFilledIcon;
